export default "__VITE_ASSET__zUKmXw0J__"